import moment from 'moment';
import * as types from './types';

const defaultState = {
  initialized: false,
  currentView: null,
  weekStyle: 'isoWeek',
  gridView: 'week',
  showReminders: true,
  calendarView: 'week',
  startDate: null,
  endDate: null,
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case types.INITIALIZE_PLANNER_UI: {
      const {
        defaultView,
        defaultCalendarView,
      } = action.payload || {};
      const resolvedGridView = state.gridView === 'day'
        ? 'day'
        : 'week';
      const allowedCalendarViews = ['month', 'week', 'day', 'agenda'];
      const defaultResolvedCalendarView = defaultCalendarView === 'month'
        ? 'month'
        : 'week';
      const resolvedCalendarView = allowedCalendarViews.includes(state.calendarView)
        ? state.calendarView
        : defaultResolvedCalendarView;
      const resolvedCurrentView = state.currentView || defaultView || 'grid';
      const useMonthRange = resolvedCurrentView === 'calendar' && resolvedCalendarView === 'month';
      const defaultStartDate = useMonthRange
        ? moment().startOf('month').toDate()
          .getTime()
        : moment().startOf(state.weekStyle || 'isoWeek').startOf('day').toDate()
          .getTime();
      const defaultEndDate = useMonthRange
        ? moment().endOf('month').toDate()
          .getTime()
        : moment().endOf(state.weekStyle || 'isoWeek').endOf('day').toDate()
          .getTime();
      return {
        ...state,
        initialized: true,
        currentView: resolvedCurrentView,
        gridView: resolvedGridView,
        showReminders: state.showReminders !== false,
        calendarView: resolvedCalendarView,
        startDate: state.startDate || defaultStartDate,
        endDate: state.endDate || defaultEndDate,
      };
    }
    case types.SET_PLANNER_CURRENT_VIEW:
      return {
        ...state,
        initialized: true,
        currentView: action.currentView,
      };
    case types.SET_PLANNER_WEEK_STYLE:
      return {
        ...state,
        initialized: true,
        weekStyle: action.weekStyle,
      };
    case types.SET_PLANNER_GRID_VIEW:
      return {
        ...state,
        initialized: true,
        gridView: action.gridView,
      };
    case types.SET_PLANNER_SHOW_REMINDERS:
      return {
        ...state,
        initialized: true,
        showReminders: action.showReminders !== false,
      };
    case types.SET_PLANNER_CALENDAR_VIEW:
      return {
        ...state,
        initialized: true,
        calendarView: action.calendarView,
      };
    case types.SET_PLANNER_START_DATE:
      return {
        ...state,
        initialized: true,
        startDate: action.startDate,
      };
    case types.SET_PLANNER_END_DATE:
      return {
        ...state,
        initialized: true,
        endDate: action.endDate,
      };
    default:
      return state;
  }
};
